import React, { useMemo } from "react";
import PropTypes from 'prop-types';
import { Field } from "@progress/kendo-react-form";
import { FormCheckbox, FormDropDownList, FormNumericTextBox, FormInput, FormMultiSelect } from "commons/forms/form";
import { required, isAuthorizedCharacter } from "commons/forms/validators";
import { DIFFUSEURS, FORMATSPAGE } from "../constants/types";
import { useGetDiffuseursQuery, useGetFournisseursQuery, useGetMagasinsQuery, useGetMediasQuery, useGetReseauxQuery, useGetTypeEnvoiInstructionsQuery } from "../../../redux/api/cache";

export default function FormControls(props) {
    const getStatut = () => {
        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                component={FormCheckbox}
            />
        );
    };

    const getMagasins = () => {
        const { data: storesDropdown } = useGetMagasinsQuery();

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                data={storesDropdown?.data?.map(
                    (item) => item.mag_nom
                )}
                component={FormMultiSelect}
            />
        );
    };

    const getFournisseurs = () => {
        const { data: four } = useGetFournisseursQuery('');

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                data={four?.data?.map((item) => `${item.four_nom} (${item.four_cd})`)}
                component={FormDropDownList}
            />
        );
    };

    const getEnvoiInstructions = () => {
        const { data: typeEnvoie } = useGetTypeEnvoiInstructionsQuery();

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                data={typeEnvoie?.data?.map(
                    (item) => item.typeEnvoi
                )}
                component={FormDropDownList}
            />
        );
    };

    const getMedias = () => {
        const { data: media } = useGetMediasQuery();
        const mediaValidator = (e) => required(e, "Média");

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                data={media?.data?.map((item) => item.media_cd)}
                style={{
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                disabled={(props.title === 'Medias' && !props.form) || (props.id === FORMATSPAGE && props.modification)}
                component={
                    props.title === 'Diffuseurs'
                        ? FormMultiSelect
                        : props.title === 'Medias'
                            ? FormInput
                            : FormDropDownList
                }
                validator={mediaValidator}
            />
        );
    };

    const getReseaux = () => {
        const { data: reseaux } = useGetReseauxQuery();
        const reseauxValidator = useMemo(() => [(e) => required(e, props.label), (e) => isAuthorizedCharacter(e)], []);

        if (props.id === DIFFUSEURS)
            return (
                <Field
                    id={props.defKey}
                    name={props.defKey}
                    label={props.label}
                    style={{
                        fontSize: '14px',
                        border: '0',
                        borderRadius: '0',
                    }}
                    data={reseaux?.data?.map((item) => item.res_descr)}
                    component={FormDropDownList}
                />
            );

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    backgroundColor: '#f3f5f5',
                    color: 'black',
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                maxLenght={props.label === 'Code' ? 7 : 10000}
                readOnly={
                    props.defKey === props.firstCol && !props.form
                        ? 'readOnly'
                        : ''
                }
                disabled={props.defKey === props.firstCol && !props.form}
                component={FormInput}
                validator={reseauxValidator}
            />
        );
    };

    const getCodesDiffuseursThematiques = () => {
        const { data: diffuseurs } = useGetDiffuseursQuery();
        const diffuseurThematiqueValidator = useMemo(() => [(e) => required(e, props.label), (e) => isAuthorizedCharacter(e)], []);

        if (props.defKey === 'diff_cd' && props.id === FORMATSPAGE)
            return (
                <Field
                    id={props.defKey}
                    name={props.defKey}
                    disabled={props.modification}
                    label={props.label}
                    style={{
                        fontSize: '14px',
                        border: '0',
                        borderRadius: '0',
                    }}
                    data={diffuseurs?.data?.filter(d => d.diff_statut).map((item) => item.diff_nom)}
                    component={FormDropDownList}
                />
            );

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    backgroundColor: '#f3f5f5',
                    color: 'black',
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                disabled={props.modification}
                maxLenght={20}
                component={FormInput}
                validator={diffuseurThematiqueValidator}
            />);
    };

    const getDiffuseursThematiques = () => {
        const diffuseurThematiqueValidator = (e) => required(e, props.label);

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    backgroundColor: '#f3f5f5',
                    color: 'black',
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                maxLenght={10000}
                component={FormInput}
                validator={diffuseurThematiqueValidator}
            />);
    };

    const getMFFormat = () => {
        const affichageValidator = useMemo(() => [(e) => required(e, props.label), (e) => isAuthorizedCharacter(e)], []);

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    backgroundColor: '#f3f5f5',
                    color: 'black',
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                maxLenght={props.label === 'Code' ? 7 : 10000}
                readOnly={
                    props.defKey === props.firstCol && !props.form
                        ? 'readOnly'
                        : ''
                }
                disabled={props.defKey === props.firstCol && !props.form}
                component={FormInput}
                validator={affichageValidator}
            />
        );
    };

    const getMFSequence = () => {
        const count = props.data?.filter(d => d.media_cd === props.rowData.media_cd && d.diff_cd === props.rowData.diff_cd).length;

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    backgroundColor: '#f3f5f5',
                    color: 'black',
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                component={FormNumericTextBox}
                min={1}
                max={count}
            />);
    };

    const getDefault = () => {
        const affichageValidator = (e) => { return props.defKey === props.firstCol ? required(e, props.label) : ""; };

        return (
            <Field
                id={props.defKey}
                name={props.defKey}
                label={props.label}
                style={{
                    backgroundColor: '#f3f5f5',
                    color: 'black',
                    fontSize: '14px',
                    border: '0',
                    borderRadius: '0',
                }}
                maxLenght={props.label === 'Code' ? 7 : 10000}
                readOnly={
                    props.defKey === props.firstCol && !props.form
                        ? 'readOnly'
                        : ''
                }
                disabled={props.defKey === props.firstCol && !props.form}
                component={FormInput}
                validator={affichageValidator}
            />
        );
    };

    switch (props.defKey) {
        case 'diff_statut':
            return getStatut();
        case 'mag_num_lst':
            return getMagasins();
        case 'four_cd':
            return getFournisseurs();
        case 'diff_envoi_instruct':
            return getEnvoiInstructions();
        case 'media_cd':
            return getMedias();
        case 'res_cd':
            return getReseaux();
        case 'diff_cd':
        case 'them_cd':
            return getCodesDiffuseursThematiques();
        case 'diff_nom':
        case 'them_descr':
            return getDiffuseursThematiques();
        case 'mf_sequence':
            return getMFSequence();
        case 'mf_format':
            return getMFFormat();
        default:
            return getDefault();
    }
}


FormControls.propTypes = {
    defKey: PropTypes.string,
    label: PropTypes.string,
    i: PropTypes.number,
    id: PropTypes.string,
    title: PropTypes.string,
    form: PropTypes.bool,
    firstCol: PropTypes.string,
    modification: PropTypes.bool,
    data: PropTypes.any,
    rowData: PropTypes.any
};